package horcrux.frontend.common.views.collections

import horcrux.frontend.common.views.components.input.InstructionsWithHelp
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.h2
import web.cssom.AlignItems

val EmptyCollectionMessage = FC<Props> {
    Stack {
        this.direction = responsive(StackDirection.column)
        this.sx {
            this.alignItems = AlignItems.center
        }
        h2 { +"Your Collection Is Empty" }
        InstructionsWithHelp {
            this.id = "document-import-instructions"
            this.instructions = "Try Importing Documents Into It"
            this.helpText =
                """This collection is empty. Click on the button above to import documents into it.""".trimIndent()
        }
    }
}
